import { rei } from "@/services/api"
import axios from 'axios'

class FornecedorService {
  static getFornecedores (params) {
    return rei.get(`fornecedor`, {params}).then(res => res.data)
  }

  static cadastrarFornecedor (fornecedor) {
    return rei.post(`fornecedor`, fornecedor).then(res => res.data)
  }

  static atualizarFornecedor (fornecedor, id) {
    return rei.put(`fornecedor/${id}`, fornecedor).then(res => res.data)
  }

  static excluirFornecedor (id) {
    return rei.delete(`fornecedor/${id}`)
  }

  static getByCNPJ (cnpj) {
    const config = {
      headers: {
        'x-rapidapi-host': 'consulta-cnpj-gratis.p.rapidapi.com',
        'x-rapidapi-key': '38112553b7msh7174ad4acbaf69dp185338jsnb2d955fcf38d'
      }
    }

    const url = `https://consulta-cnpj-gratis.p.rapidapi.com/companies/${cnpj}`

    return axios.get(url, config).then(res => res.data)
  }
}

export default FornecedorService
